import { useTranslation } from "react-i18next";
import { useSiteSettings } from "@/site/SiteSettingsContext";

export default function Footer() {
  const { t } = useTranslation("common");
  const { settings } = useSiteSettings();
  const logoUrl = settings?.logoUrl?.trim();
  const siteName = settings?.siteName?.trim() || t("appName");

  return (
    <footer className="bg-navy-50 border-t border-gray-100">
      <div className="w-full px-4 md:px-8 py-6 md:py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            {logoUrl ? (
              <img src={logoUrl} alt={siteName} className="w-7 h-7 object-contain" />
            ) : (
              <div className="w-7 h-7 rounded-md bg-primary-400 flex items-center justify-center">
                <i className="ri-seedling-line text-white text-sm" />
              </div>
            )}
            <span className="text-sm font-medium text-navy-400">
              {siteName}
            </span>
          </div>
          <p className="text-xs text-gray-500 text-center">
            {t("footerTagline")}
          </p>
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} {t("footerRights")}
          </p>
        </div>
      </div>
    </footer>
  );
}